import { FEATURE_MNG } from '@/api/apiModules'
export default {
  refreshInterval: false,
  viewType: 'table',
  module: FEATURE_MNG,
  relationSearch: true,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  params: null,
  allowStatus: {
    featureRelateTestCase: {
      expression: function(row) {
        return row.productVersion
      }
    }
  },
  toolbar: {
    searchWidth: 420,
    searchMaxlength: 168,
    searchPlaceholder: '请输入产品版本/功能名/功能编码/业务诉求【主打价值】',
    moreBtnWidth: 160,
    searchFieldNameArr: ['productVersion', 'featureName', 'featureCode', 'valueDesc'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'featureCreate'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          label: '功能名',
          prop: 'featureName'
        },
        action: 'featureDetail',
        dataType: 'link'
      },
      {
        props: {
          label: '功能编码',
          prop: 'featureCode',
          width: 120
        }
      },
      {
        props: {
          label: '版本支持',
          prop: 'productId',
          width: 200
        },
        dataType: 'custom',
        custom(row, _h, value, e) {
          return row.productVersion
        },
        filter: true,
        url: `feature/listProduct`
      },
      {
        props: {
          label: '售前功能类型',
          prop: 'featureType',
          width: 120
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'featureType'
      },
      {
        props: {
          label: '交付功能类型',
          prop: 'deliveryFeatureType',
          width: 120
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'deliveryFeatureType'
      },
      {
        props: {
          label: '业务诉求【主打价值】',
          prop: 'valueDesc',
          width: 200
        },
        filter: true,
        url: `featureValue/listForFilter`
      },

      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 180
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime',
          width: 180
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '2'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '关联用例',
        command: 'featureRelateTestCase',
        name: 'featureRelateTestCase',
        tip: '功能的版本支持不能为空'
      },
      {
        icon: 'el-icon-edit',
        label: 'edit',
        command: 'featureEdit',
        name: 'edit'
      },
      {
        icon: 'el-icon-delete',
        label: 'delete',
        command: 'featureDelete',
        name: 'delete',
        confirm: {
          msg: 'tips.confirm.featureMng.deleteMsg'
        }
      },
      {
        icon: 'el-icon-edit',
        label: '复制',
        command: 'FeatureCopy',
        name: 'FeatureCopy'
      }
    ]
  }
}
